import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  NumberInput,
  required,
} from 'react-admin';

export const VacancyCategoryEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput 
        source="name" 
        validate={[required()]} 
        fullWidth 
      />
      <TextInput 
        source="slug" 
        helperText="Оставьте пустым для автогенерации из названия"
        fullWidth 
      />
      <BooleanInput 
        source="isActive" 
      />
      <NumberInput 
        source="sortOrder" 
        min={0}
      />
    </SimpleForm>
  </Edit>
);
